import { render } from "./AddReglement.vue?vue&type=template&id=3c505a62&scoped=true&ts=true"
import script from "./AddReglement.vue?vue&type=script&lang=ts"
export * from "./AddReglement.vue?vue&type=script&lang=ts"

import "./AddReglement.vue?vue&type=style&index=0&id=3c505a62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c505a62"]])

export default __exports__